import React, { useEffect, useState } from 'react';
import Button from 'components/common/Buttons';
import List from './ProductPricingCardList';
import Label from 'components/Label';
import { convertToCent, getPriceTierAmount } from '../helpers';
import TabButton from './TabButton';
import { useSelector } from 'react-redux';
import { selectPingProductsIsLoading } from 'store/slices/PricingSlice';
import { getImageUrl } from 'helpers';
import useAnalyticsEventTracker from 'hooks/useAnalyticsEventTracker';
import useMediaQuery from 'hooks/useMediaQuery';
import { links } from 'constants/links';





const ProductPricingCard = ({ data, fields, sliderValue, selectedTab = 0, additionalComponent }) => {
    const isLoading = useSelector(selectPingProductsIsLoading);
    const isTablet = useMediaQuery('max-width: 1024px')
    const isNumber = typeof sliderValue === 'number';
    const value = isNumber ? sliderValue : sliderValue.realValue;

    const { product_prices } = data;
    const [pricePerUnit, setPricePerUnit] = useState(0);
    const [finalPrice, setFinalPrice] = useState(0);
    const [currentInterval, setCurrentInterval] = useState(selectedTab);
    const [quantityText, setQuantityText] = useState(isNumber ? value : sliderValue.label);

    const [currentPriceTiers, setCurrentPriceTiers] = useState(product_prices?.[currentInterval]?.price_tiers);
    const eventTracker = useAnalyticsEventTracker({ category: "User", action: "Buy Now Click" });
    const handleSetCurrentTiers = index => {
        setCurrentInterval(index);
    };
    useEffect(() => {
        setCurrentPriceTiers(product_prices?.[currentInterval]?.price_tiers);
    }, [isLoading, currentInterval, product_prices]);
    useEffect(() => {
        if (currentPriceTiers) {
            setPricePerUnit(convertToCent(getPriceTierAmount(value, currentPriceTiers)));
            setFinalPrice(Number((pricePerUnit * value).toFixed(2)));
            setQuantityText(isNumber ? `${value} IP` : sliderValue.label);
        }
    }, [value, pricePerUnit, isNumber, sliderValue, currentPriceTiers]);

    if (!fields) return
    const { button_text,
        color_list_icon,
        name,
        price_per_unit_text,
        quantity_text,
        card_items,
        icon,
        discount_text } = fields
    const imageUrl = getImageUrl(icon)
    return (
        <div className="product-price-card">
            <div className="product-price-card-header">
                <div className="product-price-card__icon" style={{ color: color_list_icon }}><img src={imageUrl} alt="" /></div>
                <div className="body1 product-price-card__info-title">{name}</div>
            </div>

            <div className="product-price-card-tabs">
                {product_prices?.map(({ price_cycle_interval, price_cycle_interval_count }, index) => (
                    <TabButton
                        key={index}
                        index={index}
                        onClick={handleSetCurrentTiers}
                        currentInterval={currentInterval}
                        price_cycle_interval={price_cycle_interval}
                        price_cycle_interval_count={price_cycle_interval_count}
                    />
                ))}
            </div>

            {
                isTablet && additionalComponent
            }

            <div className="product-price-card__price-container">
                <div className="product-price-card__prices">
                    {/* {price !== discountedPrice && (
                        <div className="description1 product-price-card__price-old">${price}</div>
                    )} */}
                    <div className="description1">$ {pricePerUnit}</div>
                    <div className="body2">{price_per_unit_text}</div>

                </div>
                {discount_text && <Label text={`${discount_text}`} />}
            </div>

            <div className="product-price-card-counts">
                <div className="product-price-card-counts-item">
                    <span>
                        <div className="body2">{quantity_text}</div>
                    </span>
                    <div className="body2">{quantityText}</div>
                </div>
                <div className="product-price-card-counts-item">
                    <div className="body1">Total</div>
                    <div className="body2">${finalPrice}</div>
                </div>
            </div>

            <List color={color_list_icon} lists={card_items} />

            <Button text={button_text} onClick={eventTracker} to={links.dashbord} target={true} />
        </div >
    );
};

export default ProductPricingCard;